import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PasswordResetIcon from "@mui/icons-material/LockReset";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { AxiosError } from "axios";
import { useEffect, useRef, useState } from "react";
import { Row, Spinner, Table } from "react-bootstrap";
import { USER_APIS } from "../../api/apis";
import { get, getAxiosHeaders, patch } from "../../shared/AxiosAPI";
import { UserDTO, UserRole } from "../../shared/types";
import { getStaticGrades, getStaticSections } from "../../shared/Util";
import { getLoggedInUserRole } from "../../user/UserService";
import { getInitialUser } from "./UserAPI";

interface UserProps {
  operation: string;
}
export const User = ({ operation }: UserProps) => {
  const DISPLAY_AVAILABLE_USERS = "DISPLAY_AVAILABLE_USERS";
  const ADD_NEW_USER = "ADD_NEW_USER";
  const LOADING_USERS = "LOADING_USERS";
  const userTypes = ["FACULTY", "STUDENT", "ADMIN"]; //PARENT
  const initialUser = getInitialUser();
  const [user, setUser] = useState<UserDTO>(initialUser);
  const [users, setUsers] = useState<UserDTO[]>([]);
  const [view, setView] = useState<string>(LOADING_USERS);
  const [gradeSelectionEnabled, setGradeSelectionEnabled] = useState<boolean>(true);
  const [currentUserType, setCurrentUserType] = useState<string>("FACULTY");
  const [validated, setValidated] = useState(false);
  const [usersLoaded, setUsersLoaded] = useState<boolean>(false);
  const [loggedInUserRole, setLoggedInUserRole] = useState<string>(getLoggedInUserRole());

  const studentRoleRef = useRef<HTMLInputElement>(null);
  const facultyRoleRef = useRef<HTMLInputElement>(null);
  const adminRoleRef = useRef<HTMLInputElement>(null);
  const userTypeRef = useRef<HTMLSelectElement>(undefined);

  const cancelAF = () => {
    console.log("cancelAF");
    setView(DISPLAY_AVAILABLE_USERS);
  };

  const loadUsers = async (userType: string, grade: string, sectoin: string) => {
    let cHeaders = getAxiosHeaders();
    if ("STUDENT" === userType) {
      cHeaders.set("grade", grade);
      cHeaders.set("section", sectoin);
    }
    try {
      let res = await get(USER_APIS.USERS_TYPE.replace("user_type", userType), cHeaders);

      let users = res.data;
      setUsers([...users]);
      setView(DISPLAY_AVAILABLE_USERS);
      setUsersLoaded(true);
    } catch (err) {
      alert(err)
    }
  };

  useEffect(() => {
    loadUsers(currentUserType, undefined, undefined);
  }, []);

  const userTypeChanged = (selectedUType: string) => {
    setCurrentUserType(selectedUType);
    setUsersLoaded(false);
  };
  const updateGradeSelectionEnabled = () => {
    if (studentRoleRef.current.checked) {
      if (facultyRoleRef.current.checked || adminRoleRef.current.checked) {
        setGradeSelectionEnabled(true);
      } else {
        setGradeSelectionEnabled(false);
      }
    } else {
      setGradeSelectionEnabled(true);
    }
  };
  const fetchUsers = (form: React.FormEvent<HTMLFormElement>) => {
    form.preventDefault();
    let formData = new FormData(form.currentTarget);
    let grade = formData.get("std_grade")?.valueOf().toString();
    let section = formData.get("std_section")?.valueOf().toString();
    let userType = formData.get("userType").valueOf().toString();
    loadUsers(userType, grade, section);
  };

  const resetPassword = (loginId: string) => {
    let url = USER_APIS.RESET_PASSWORD.replace("loginId_value", loginId);
    patch(url, null, null)
      .then((res) => {
        if (res.status === 200) {
          alert("User password reset");
        }
      })
      .catch((err: AxiosError) => {
        alert(err.message);
      });
  };
  return (
    <>
      {view === LOADING_USERS ? <Spinner animation="border" /> : ""}
      {view === DISPLAY_AVAILABLE_USERS ? (
        <>

          <Box component="form" onSubmit={fetchUsers} sx={{ display: "flex", gap: 1, p: 2 }}>
            <Grid>
              <FormControl sx={{ minWidth: 130 }} size="small">
                <InputLabel id="userType-label">User Type</InputLabel>
                <Select
                  labelId="userType-select-label"
                  id="userType-select"
                  name="userType"
                  label="User Type"
                  defaultValue={currentUserType}
                  onChange={(e) => userTypeChanged(e.target.value)}
                >
                  {userTypes.map((userType: string) => (
                    <MenuItem value={userType} key={userType}>
                      {userType}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {currentUserType === "STUDENT" ? (
              <>
                <Grid>
                  <FormControl sx={{ minWidth: 130 }} size="small">
                    <InputLabel id="grade-label">Grade</InputLabel>
                    <Select labelId="grade-select-label" id="grade-select" name="std_grade" label="Grade" defaultValue={"PRE-KG"}>
                      {getStaticGrades()?.map((grade: string) => (
                        <MenuItem value={grade} key={grade}>
                          {grade}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid>
                  <FormControl sx={{ minWidth: 130 }} size="small">
                    <InputLabel id="section-label">Grade</InputLabel>
                    <Select labelId="section-select-label" id="section-select" name="std_section" label="Section" defaultValue={"A"}>
                      {getStaticSections()?.map((section: string) => (
                        <MenuItem value={section} key={section}>
                          {section}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </>
            ) : (
              ""
            )}
            <Grid style={{ marginTop: "5px" }}>
              <Button size="small" type="submit" variant="contained" color="primary">
                Get
              </Button>
            </Grid>
          </Box>
          <br />
          {usersLoaded && users.length > 0 ? (
            <Box>
              <Grid>
                <TableContainer
                  component={Paper}
                  sx={{
                    margin: "auto",
                    mt: 2,
                  }}
                >
                  <Typography variant="h6" sx={{ ml: 2 }}>
                    Users
                  </Typography>
                  <Table>
                    <TableHead>
                      <TableRow key={user.name}>
                        <TableCell>Name</TableCell>
                        {currentUserType === "STUDENT" ? <TableCell>Admission No</TableCell> : ""}
                        <TableCell>Login Id</TableCell>
                        {currentUserType !== "STUDENT" ? <TableCell>Mobile No</TableCell> : ""}

                        <TableCell>Operations</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {users.length > 0 && users?.map((user: UserDTO) => (
                        <TableRow key={user.mobile}>
                          <TableCell>{user.name}</TableCell>
                          {currentUserType === "STUDENT" ? <TableCell>{user.admissionNo}</TableCell> : ""}
                          <TableCell>{user.loginId}</TableCell>
                          {/* What a faculty teaches is shown in Faculty > Directory (from faculty_assignment) */}
                          {currentUserType !== "STUDENT" ? <TableCell>{user.mobile}</TableCell> : ""}

                          <TableCell>
                            <Box display="flex" flexDirection="row" gap={1}>
                              <Grid>
                                <Tooltip title="Passowrd Reset">
                                  <PasswordResetIcon onClick={(e) => resetPassword(user.loginId)} sx={{ color: "#0080ff" }} />
                                </Tooltip>
                              </Grid>

                              {loggedInUserRole === UserRole.ADMIN && (
                                <>
                                  <Grid>
                                    <Tooltip title="Edit">
                                      <EditIcon onClick={(e) => alert("In progres")} sx={{ color: "green" }} />
                                    </Tooltip>
                                  </Grid>
                                  <Grid>
                                    <Tooltip title="Delete">
                                      <DeleteIcon onClick={(e) => alert("In progres")} sx={{ color: "red", cursor: "pointer" }} />
                                    </Tooltip>
                                  </Grid>
                                </>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Box>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )
      }

      {view !== LOADING_USERS && view !== ADD_NEW_USER ? <Row></Row> : ""}
      <br />
    </>
  );
};
